import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessAverageIssueAgeRoute: InvariantJiraRoute = {
	name: 'classic-business-reports-average-issue-age',
	path: '/jira/core/projects/:projectKey/reports/average-age',
};
